var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HitRate',{attrs:{"title":"Overall Hit Rate"}}),_c('h2',[_vm._v("Watched Totals")]),_c('BaseCard',{attrs:{"isDisabled":_vm.prefixes && _vm.prefixes.length === 0}},[_c('BaseStats',{attrs:{"stats":[
        {
          value: _vm.getPercentByMetric('prefix_over_compound_requests'),
          label: _vm.metricLabel('prefix_over_compound_requests'),
          icon: 'question-circle',
          iconToolTip: 'Total watched % of recent requests',
          small: true,
          labelNarrow: true,
          iconBlock: true,
        },
        {
          value: _vm.getPercentByMetric('prefix_over_compound_num_keys'),
          label: _vm.metricLabel('prefix_over_compound_num_keys'),
          icon: 'question-circle',
          iconToolTip: 'Total watched % of recently active items',
          small: true,
          labelNarrow: true,
          iconBlock: true,
        },
        {
          value: _vm.getPercentByMetric('prefix_over_compound_total_size'),
          label: _vm.metricLabel('prefix_over_compound_total_size'),
          icon: 'question-circle',
          iconToolTip: 'Total watched % of recently active memory',
          small: true,
          labelNarrow: true,
          iconBlock: true,
        } ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }